// Returns the row-number label (e.g. "3.") for a subtask, counting only
// non-heading rows so headings stay unnumbered and the visible sequence of
// actionable items remains contiguous. Returns "" for heading rows.
//
// getType receives a subtask entry and returns its type string. This lets the
// same helper serve both raw subtasks ((s) => s.type) and subtask assignments
// ((s) => s.plan_subtask?.type).
export function getSubtaskNumberLabel(subtasks, index, getType) {
  if (!subtasks || getType(subtasks[index]) === "heading") return "";
  let n = 0;
  for (let i = 0; i <= index; i++) {
    if (getType(subtasks[i]) !== "heading") n++;
  }
  return `${n}.`;
}
